import Loading from '../Loading';
import React, { useState, useEffect } from 'react';
import Pagination from './Pagination';
import { useNavigate } from 'react-router-dom';
import './FullTextView.css';
import progressNotesService from '../../services/Progressnotesservice';

const FullTextView = ({ onBackToList }) => {
  // Removed navigate, use prop for switching view
  const [currentPage, setCurrentPage] = useState(1);
  const [progressNotes, setProgressNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const itemsPerPage = 16;
  const [totalPages, setTotalPages] = useState(0);

  const fetchFullTextView = async () => {
    try {
      setLoading(true);
      setError(null);
      // Always fetch all records, paginate client-side
      const offsetSize = '0';
      const data = await progressNotesService.getFullTextView(offsetSize, '1');
      setProgressNotes(data || []);
      setTotalPages(Math.ceil((data?.length || 0) / itemsPerPage));
    } catch (err) {
      setError(err.message);
      console.error('Error fetching full text view:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchFullTextView();
  }, []);

  // Extract encrypted parameters from sessionStorage, fallback to URL params
  const params = new URLSearchParams(window.location.search);
  let encryptedParams = null;
  try {
    const raw = sessionStorage.getItem('progressNotesEncryptedParams');
    if (raw) {
      encryptedParams = JSON.parse(raw);
    }
  } catch (e) {
    encryptedParams = null;
  }
  const sessionId = encryptedParams?.SessionId || params.get('SessionId');
  const patientId = encryptedParams?.PatientId || params.get('PatientId');
  const authType = encryptedParams?.AuthType || params.get('AuthType');

  // Use prop to switch back to ListView
  const handleListView = () => {
    if (typeof onBackToList === 'function') {
      onBackToList();
    }
  };

  const handleExportToPDF = async () => {
    try {
      setLoading(true);
      const offsetSize = (currentPage - 1).toString();
      // Get the HTML content of the progress notes section
      const notesContentElement = document.querySelector('.progress-notes-content');
      let htmlContent = '';
      if (notesContentElement) {
        htmlContent = notesContentElement.outerHTML;
      } else {
        htmlContent = '<div>No progress notes available</div>';
      }
  await progressNotesService.exportToPDF(offsetSize, '0', htmlContent);
    } catch (error) {
      setError('Failed to export PDF: ' + error.message);
      console.error('Error exporting PDF:', error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const formatBodyContent = (note) => {
    if (!note?.body) return null;
    let bodyData = typeof note.body === 'string' ? JSON.parse(note.body) : note.body;


    if (note.type_Id === 3 && note.event_Id === 54 && bodyData.MILESTONE && Array.isArray(bodyData.MILESTONE)) {
      return (
        <div className="type-milestone-list">
          {bodyData.MILESTONE.map((ms, idx) => (
            <div key={idx} style={{ padding: 16, marginBottom: 16 }}>
              <table style={{ width: '100%' }}>
                <tbody>
                  <tr>
                    <td className="FLabel" style={{ width: '25%', fontWeight: 'bold', color: 'black' }}>Member Priority:</td>
                    <td className="BaseFont" style={{ width: '25%' }}>{ms.ms_member_goal_priority_id_verbose || ''}</td>
                    <td className="FLabel" style={{ width: '25%', fontWeight: 'bold', color: 'black' }}>Milestone Action Type:</td>
                    <td className="BaseFont" style={{ width: '25%' }}>{ms.ms_action_type_verbose || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Target:</td>
                    <td className="BaseFont">{ms.ms_target_mask_string || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Due Date:</td>
                    <td className="BaseFont">{ms.ms_due_date || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Original Due Date:</td>
                    <td className="BaseFont">{ms.ms_original_due_date || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Associated Goal:</td>
                    <td className="BaseFont">{ms.ms_goal || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Additional Notes:</td>
                    <td className="BaseFont">{ms.ms_additional_notes || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Type:</td>
                    <td className="BaseFont">{ms.ms_type_verbose || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Name:</td>
                    <td className="BaseFont" colSpan={3}>{ms.ms_name || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Assigned To:</td>
                    <td className="BaseFont" colSpan={3}>{ms.ms_user_name || ''}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}
        </div>
      );
    }

     if (note.type_Id === 3 && note.event_Id === 45) {
          return (
            <div className="type-milestone-details">
              <table style={{ width: '100%' }}>
                <tbody>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Milestone Name:</td>
                    <td className="BaseFont">{bodyData.ms_name || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Member Priority:</td>
                    <td className="BaseFont">{bodyData.ms_member_goal_priority_id_verbose || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Case Name:</td>
                    <td className="BaseFont">{bodyData.case_name || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Problem Name:</td>
                    <td className="BaseFont">{bodyData.problem_name || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Assigned To:</td>
                    <td className="BaseFont">{decodeURIComponent(bodyData.ms_user_name || '')}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Due Date:</td>
                    <td className="BaseFont">{bodyData.ms_duedate || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Action Type:</td>
                    <td className="BaseFont">{bodyData.ms_action_type_verbose || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Type:</td>
                    <td className="BaseFont">{bodyData.ms_type_verbose || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Milestone Category:</td>
                    <td className="BaseFont">{bodyData.ms_category || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Associated Goal:</td>
                    <td className="BaseFont">{bodyData.ms_goal || ''}</td>
                  </tr>
                </tbody>
              </table>
              <div style={{ marginTop: 24 }}>
                <span className="FLabel" style={{ fontWeight: 'bold', color: '#086bb5' }}>Notes:</span>
                {bodyData.html && (
                  <div style={{ marginTop: 8 }} dangerouslySetInnerHTML={{ __html: bodyData.html }} />
                )}
              </div>
            </div>
          );
        }

    // For care plan and milestone notes (Type_Id: 5, 3, 31, 34)
    if (note.type_Id === 5 || note.type_Id === 3 || note.type_Id === 31 || note.type_Id === 34) {
      // Handle milestone and care plan updates
      if (bodyData.ms_name || bodyData.milestone_name || bodyData.Milestone_Name) {
        return (
          <div className="type-milestone">
            <table className="data-table">
              <tbody>
                <tr>
                  <td className="FLabel" width="15%">Assigned To:</td>
                  <td className="BaseFont">{bodyData.Assigned_To || bodyData.assigned_to || bodyData.ms_user_name}</td>
                  <td className="FLabel" width="15%">Milestone Due Date:</td>
                  <td className="BaseFont">{bodyData.Milestone_Due_Date || bodyData.ms_due_date}</td>
                </tr>
                <tr>
                  <td className="FLabel">Milestone Type:</td>
                  <td className="BaseFont">{bodyData.Milestone_Type || bodyData.ms_type_verbose}</td>
                  <td className="FLabel">Milestone Action Type:</td>
                  <td className="BaseFont">{bodyData.ms_action_type_verbose}</td>
                </tr>
                <tr>
                  <td className="FLabel">Milestone Name:</td>
                  <td className="BaseFont" colSpan="3">{bodyData.ms_name || bodyData.milestone_name}</td>
                </tr>
                {bodyData.ms_category && (
                  <tr>
                    <td className="FLabel">Milestone Category:</td>
                    <td className="BaseFont" colSpan="3">{bodyData.ms_category}</td>
                  </tr>
                )}
                <tr>
                  
                  <td className="FLabel">Milestone Category:</td>
                  <td className="BaseFont">{bodyData.ms_category || ''}</td>
                  <td className="FLabel">Member Priority:</td>
                  <td className="BaseFont">{bodyData.ms_member_goal_priority_id_verbose || bodyData.Member_Priority || ''}</td>
                </tr>
                <tr>
                  <td className="FLabel">Associated Goal:</td>
                  <td className="BaseFont" colSpan="3">{bodyData.associated_goal || bodyData.ms_goal || ''}</td>
                </tr>
                <tr>
                  <td className="FLabel">Status:</td>
                  <td className="BaseFont" colSpan="3">{bodyData.status || ''}</td>
                </tr>
                <tr>
                  <td className="FLabel">Change Reason:</td>
                  <td className="BaseFont" colSpan="3">{bodyData.change_reason || bodyData.Change_Reason || ''}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }

      //Test
     
      //End

      
      // Handle consent updates
      if (note.event_Id === 40 || note.event_Id === 41 || (bodyData.consent_type_desc && bodyData.case_name)) {
        // Render consent note with highlighted Milestones label and boxed milestone content
        return (
          <div className="type-consent">
            <table className="data-table" style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td className="FLabel" width="25%">Case Name:</td>
                  <td className="BaseFont" width="25%">{bodyData.case_name}</td>
                  <td className="FLabel" width="25%">Consent Status:</td>
                  <td className="BaseFont" width="25%">{bodyData.consent_type_desc}</td>
                </tr>
                <tr>
                  <td className="FLabel">Consent Method:</td>
                  <td className="BaseFont">{bodyData.consent_method_desc}</td>
                  <td className="FLabel">Consent Reason:</td>
                  <td className="BaseFont">{bodyData.consent_reason}</td>
                </tr>
                <tr>
                  <td className="FLabel">Milestones:</td>
                  <td className="BaseFont" colSpan="3">
                    <div style={{ border: '2px solid #222', margin: '10px 0', padding: '10px' }}>
                      {bodyData.html ? (
                        <div dangerouslySetInnerHTML={{ __html: bodyData.html }} />
                      ) : (
                        <span>No milestones available</span>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }

      // Handle milestones and goals
      if (bodyData.ms_name || bodyData.ms_goal) {
        return (
          <div className="type-milestone">
            <table className="data-table">
              <tbody>
                {bodyData.ms_type_verbose && (
                  <tr>
                    <td className="FLabel" width="15%">Type:</td>
                    <td className="BaseFont">{bodyData.ms_type_verbose}</td>
                  </tr>
                )}
                {bodyData.ms_action_type_verbose && (
                  <tr>
                    <td className="FLabel" width="15%">Action Type:</td>
                    <td className="BaseFont">{bodyData.ms_action_type_verbose}</td>
                  </tr>
                )}
                {bodyData.ms_name && (
                  <tr>
                    <td className="FLabel">Name:</td>
                    <td className="BaseFont">{bodyData.ms_name}</td>
                  </tr>
                )}
                {bodyData.ms_goal && (
                  <tr>
                    <td className="FLabel">Goal:</td>
                    <td className="BaseFont">{bodyData.ms_goal}</td>
                  </tr>
                )}
                {bodyData.ms_due_date && (
                  <tr>
                    <td className="FLabel">Due Date:</td>
                    <td className="BaseFont">{bodyData.ms_due_date}</td>
                  </tr>
                )}
                {bodyData.ms_member_goal_priority_id_verbose && (
                  <tr>
                    <td className="FLabel">Priority:</td>
                    <td className="BaseFont">{bodyData.ms_member_goal_priority_id_verbose}</td>
                  </tr>
                )}
                {bodyData.ms_user_name && (
                  <tr>
                    <td className="FLabel">Assigned To:</td>
                    <td className="BaseFont">{bodyData.ms_user_name}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        );
      }
    }

    // For alert notes (Type_Id: 51)
    if (note.type_Id === 51) {
      return (
        <div className="type-alert">
          <table className="data-table">
            <tbody>
              <tr>
                <td className="FLabel" width="95px">Subject:</td>
                <td className="BaseFont" colSpan="3">{bodyData.alert_subject}</td>
              </tr>
              <tr>
                <td className="FLabel">Text:</td>
                <td className="BaseFont" colSpan="3">{bodyData.alert_message}</td>
              </tr>
              <tr>
                <td className="FLabel">Type:</td>
                <td className="BaseFont" colSpan="3">{bodyData.alert_source}</td>
              </tr>
              <tr>
                <td className="FLabel">Status:</td>
                <td className="BaseFont" colSpan="3">{bodyData.alert_status}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

      // For triage notes (Type_Id: 18, event_Id: 70)
      if (note.type_Id === 18 && note.event_Id === 70) {
        const bodyData = typeof note.body === 'string' ? JSON.parse(note.body) : note.body;
        return (
          <table className="data-table" style={{ width: '100%', background: 'none', margin: 0, border: 'none' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ fontWeight: 'bold', paddingLeft: '0', paddingRight: '10px', width: '90px' }}>Reason:</td>
                <td className="BaseFont" style={{ paddingLeft: '0', paddingRight: '30px' }}>{bodyData.triage_category__verbose || ''}</td>
                <td className="FLabel" style={{ fontWeight: 'bold', paddingLeft: '0', paddingRight: '10px', width: '90px' }}>Triaged To:</td>
                <td className="BaseFont" style={{ paddingLeft: '0', paddingRight: '30px' }}>{bodyData.queue_name || ''}</td>
                <td className="FLabel" style={{ fontWeight: 'bold', paddingLeft: '0', paddingRight: '10px', width: '90px' }}>Priority:</td>
                <td className="BaseFont" style={{ paddingLeft: '0' }}>{bodyData.priority__verbose || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ fontWeight: 'bold', paddingLeft: '0', paddingRight: '10px', width: '90px' }}>Description:</td>
                <td className="BaseFont" colSpan={5} style={{ paddingLeft: '0' }}>{bodyData.triage_description || ''}</td>
              </tr>
            </tbody>
          </table>
        );
      }

    // For care plan notes (Type_Id: 3)
    if (note.type_Id === 3 && note.event_Id === 15) {
      // Render guideline note as in pasted image: Guideline Name, Anchor Date, Assigned To, Associated Milestones (bullet list)
      const steps = bodyData.STEP_LIST?.STEP || [];
      const assignedTo = steps.map(step => step.user_name).filter(Boolean).join(' ');
      return (
        <div className="type-guideline">
          <table className="data-table">
            <tbody>
              <tr>
                <td className="FLabel" width="15%">Guideline Name:</td>
                <td className="BaseFont" colSpan="3">{bodyData.name || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Anchor Date:</td>
                <td className="BaseFont">{bodyData.date || bodyData.STEP_LIST?.initial_date || ''}</td>
                <td className="FLabel" width="15%">Assigned To:</td>
                <td className="BaseFont">{assignedTo}</td>
              </tr>
              <tr>
                <td className="FLabel">Associated Milestones:</td>
                <td className="BaseFont" colSpan="3">
                  <ul style={{ margin: 0, paddingLeft: '20px' }}>
                    {steps.map((step, idx) => (
                      <li key={step.guidelinestep_id || idx}>{step.guidelinestep_name}</li>
                    ))}
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    // For assessment notes (Type_Id: 2)
    if (note.type_Id === 2 ) {
      return (
        <div className="type-assessment">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" width="20%">Assessment Name:</td>
                <td className="BaseFont" width="20%">{bodyData.name || ''}</td>
                <td className="FLabel" width="20%">Assessment Version:</td>
                <td className="BaseFont" width="20%">{bodyData.version || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Assessment Score:</td>
                <td className="BaseFont">{bodyData.score || ''}</td>
                <td className="FLabel">Assessment Risk Index:</td>
                <td className="BaseFont">{bodyData.risk_index || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Assessment Start Date:</td>
                <td className="BaseFont">{bodyData.start_date || ''}</td>
                <td className="FLabel">Assessment Completed Date:</td>
                <td className="BaseFont">{bodyData.completion_date || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    // For medication notes (Type_Id: 20)
    if (note.type_Id === 20 && note.event_Id === 1) {
      // Render medication note body here if needed
      return (
        <div className="type-medication">
          <table className="data-table">
            <tbody>
              <tr>
                <td className="FLabel">Medication Name:</td>
                <td className="BaseFont">{bodyData.medication_name || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Dosage:</td>
                <td className="BaseFont">{bodyData.dosage || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Frequency:</td>
                <td className="BaseFont">{bodyData.frequency || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Prescribed By:</td>
                <td className="BaseFont">{bodyData.prescribed_by || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
     if(note.type_Id === 1 && note.event_Id === 6){
      return(
        <div className="type-user-role">
          <table className="data-table">
            <tbody>
              <tr>
                <td className="FLabel" width="15%">User name:</td>
                <td className="BaseFont">{bodyData.do_user_name || ''}</td>
                <td className="FLabel" width="15%">Role:</td>
                <td className="BaseFont">{bodyData.role_string || ''}</td>
                <td className="FLabel" width="15%">Primary</td>
                <td className="BaseFont">{bodyData.as_primary || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
    // For case close notes (Type_Id: 5, event_Id: 18)
if (note.type_Id === 5 && note.event_Id === 1) {
  return (
    <div className="type-case-close">
      <table className="data-table">
        <tbody>
          <tr>
            <td className="FLabel" width="15%">Case Name:</td>
            <td className="BaseFont">{bodyData.name || ''}</td>
            <td className="FLabel" width="15%">Case ID:</td>
            <td className="BaseFont">{note.tzix_Id || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Assigned To:</td>
            <td className="BaseFont">{bodyData.user_name || ''}</td>
            <td className="FLabel">Case Acuity:</td>
            <td className="BaseFont">{bodyData.acuity__verbose || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Original Open Date:</td>
            <td className="BaseFont">{bodyData.create_date || ''}</td>
            <td className="FLabel">Close Date:</td>
            <td className="BaseFont">{bodyData.event_date || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Original Status:</td>
            <td className="BaseFont">{bodyData.previous_status || ''}</td>
            <td className="FLabel">New Status:</td>
            <td className="BaseFont">{bodyData.new_status || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Reason:</td>
            <td className="BaseFont">{bodyData.reason_type__verbose || bodyData.reason || ''}</td>
            <td className="FLabel">Close Notes:</td>
            <td className="BaseFont">{bodyData.close_notes || ''}</td>
            <td className="FLabel">Open Notes:</td>
            <td className="BaseFont">{bodyData.open_notes || ''}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

    if (note.type_Id === 5 && note.event_Id === 2) {
      return (
        <div className="type-case-close">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Case Name:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.name || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}>Case ID:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{note.tzix_Id || bodyData.case_id || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Assigned To:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.user_name || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}>Case Acuity:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.acuity__verbose || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Main Diagnosis:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.diagnosis__verbose || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}>Case Type:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.tzix_type__verbose || bodyData.case_type || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Original Open Date:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.create_date || bodyData.original_open_date || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}>Case Phase:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.phase__verbose || bodyData.case_phase || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Consent Date:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.consent_date || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}>Case PCP:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.case_pcp || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Consenting Person:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.consenter || bodyData.consenting_person || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}></td>
                <td className="BaseFont" style={{ width: '32%'}}></td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Open Reason:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.reason || bodyData.open_reason_type__verbose || bodyData.open_reason || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}></td>
                <td className="BaseFont" style={{ width: '32%'}}></td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Description:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.body || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}></td>
                <td className="BaseFont" style={{ width: '32%'}}></td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Open Notes:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.open_notes || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}></td>
                <td className="BaseFont" style={{ width: '32%'}}></td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    if (note.type_Id === 5 && note.event_Id === 18) {
  return (
    <div className="type-case-close">
      <table className="data-table">
        <tbody>
          <tr>
            <td className="FLabel" width="15%">Case Name:</td>
            <td className="BaseFont">{bodyData.name || ''}</td>
            <td className="FLabel" width="15%">Case ID:</td>
            <td className="BaseFont">{note.tzix_Id || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Assigned To:</td>
            <td className="BaseFont">{bodyData.user_name || ''}</td>
            <td className="FLabel">Case Acuity:</td>
            <td className="BaseFont">{bodyData.acuity__verbose || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Original Open Date:</td>
            <td className="BaseFont">{bodyData.create_date || ''}</td>
            <td className="FLabel">Close Date:</td>
            <td className="BaseFont">{bodyData.event_date || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Original Status:</td>
            <td className="BaseFont">{bodyData.previous_status || ''}</td>
            <td className="FLabel">New Status:</td>
            <td className="BaseFont">{bodyData.new_status || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Reason:</td>
            <td className="BaseFont">{bodyData.reason_type__verbose || bodyData.reason || ''}</td>
            <td className="FLabel">Close Notes:</td>
            <td className="BaseFont">{bodyData.close_notes || ''}</td>
            <td className="FLabel">Open Notes:</td>
            <td className="BaseFont">{bodyData.open_notes || ''}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

// ...existing code...
    // For case open notes (Type_Id: 5, event_Id: 2)
    if (note.type_Id === 5 && note.event_Id === 2) {
      return (
        <div className="type-case-open">
          <table className="data-table">
            <tbody>
              <tr>
                <td className="FLabel" width="15%">Case Name:</td>
                <td className="BaseFont">{bodyData.name || ''}</td>
                <td className="FLabel" width="15%">Case ID:</td>
                <td className="BaseFont">{bodyData.tzix_id || note.tzix_Id || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Assigned To:</td>
                <td className="BaseFont">{bodyData.user_name || `${bodyData.fname || ''} ${bodyData.lname || ''}`}</td>
                <td className="FLabel">Case Acuity:</td>
                <td className="BaseFont">{bodyData.acuity__verbose || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Main Diagnosis:</td>
                <td className="BaseFont">{bodyData.diagnosis__verbose || ''}</td>
                <td className="FLabel">Case Type:</td>
                <td className="BaseFont">{bodyData.tzix_type__verbose || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Original Open Date:</td>
                <td className="BaseFont">{bodyData.create_date || bodyData.create_date__verbose || bodyData.open_date || bodyData.open_date__verbose || ''}</td>
                <td className="FLabel">Case Phase:</td>
                <td className="BaseFont">{bodyData.phase__verbose || ''}</td>
                <td className="FLabel">Case PCP:</td>
                <td className="BaseFont">{bodyData.case_pcp || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Open Reason:</td>
                <td className="BaseFont">{bodyData.open_reason_type__verbose || bodyData.open_reason || ''}</td>
                <td className="FLabel">Open Notes:</td>
                <td className="BaseFont">{bodyData.body || bodyData.open_notes || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

     if (note.type_Id === 6 && note.event_Id === 1) {
      return (
        <div className="type-problem">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ fontWeight: 'bold' }}>Problem Name:</td>
                <td className="BaseFont">{bodyData.name || ''}</td>
                <td className="FLabel" style={{ fontWeight: 'bold' }}>Case Name:</td>
                <td className="BaseFont">{bodyData.case_name || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ fontWeight: 'bold' }}>Assigned To:</td>
                <td className="BaseFont">{bodyData.user_name || ''}</td>
                <td className="FLabel" style={{ fontWeight: 'bold' }}>Main Diagnosis:</td>
                <td className="BaseFont">{bodyData.diagnosis || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

     if (note.type_Id === 28 && note.event_Id === 1) {
      return (
        <div className="type-letter-note">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '15%' }}>Name:</td>
                <td className="BaseFont" style={{ width: '35%' }}>{bodyData.name || ''}</td>
                <td className="FLabel" style={{ width: '15%' }}>Letter Type:</td>
                <td className="BaseFont" style={{ width: '35%' }}>{bodyData.letter_type || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Subject:</td>
                <td className="BaseFont">{bodyData.subject || ''}</td>
                <td className="FLabel">Letter ID:</td>
                <td className="BaseFont">{bodyData.tcs_document_id || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Template ID:</td>
                <td className="BaseFont">{bodyData.tcs_template_id || ''}</td>
                <td className="FLabel">Sent:</td>
                <td className="BaseFont">{bodyData.letter_status === 'Sent' ? 'Yes, Sent to Batch' : ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Original Send Date:</td>
                <td className="BaseFont">{bodyData.original_send_date || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
      if (note.type_Id === 28 && note.event_Id === 49) {
        const bodyData = typeof note.body === 'string' ? JSON.parse(note.body) : note.body;
        return (
          <div className="type-letter-contact">
            <table className="data-table" style={{ width: '100%' }}>
              <tbody>
                <tr>
                  <td className="FLabel" style={{ width: '15%' }}>Name:</td>
                  <td className="BaseFont" style={{ width: '35%' }}>{bodyData.name || ''}</td>
                 
                </tr>
                <tr>
                   <td className="FLabel">Subject:</td>
                  <td className="BaseFont">{bodyData.subject || ''}</td>
                  
                </tr>
                <tr>
                 
                  <td className="FLabel">Letter ID:</td>
                  <td className="BaseFont">{bodyData.tcs_document_id || ''}</td>
                   <td className="FLabel" style={{ width: '15%' }}>Letter Type:</td>
                  <td className="BaseFont" style={{ width: '35%' }}>{bodyData.letter_type || ''}</td>
                </tr>
                <tr>
                  <td className="FLabel">Template ID:</td>
                  <td className="BaseFont">{bodyData.tcs_template_id || ''}</td>
                
                </tr>
                <tr>
                    <td className="FLabel">Sent:</td>
                  <td className="BaseFont">{bodyData.letter_status === 'Draft' ? 'No' : 'Yes'}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }
    
// ...existing code...
    // For case creation/update notes
    // if (bodyData.Case_Name || bodyData.case_name) {
    //   return (
    //     <div className="type-case">
    //       <table className="data-table">
    //         <tbody>
    //           <tr>
    //             <td className="FLabel" width="15%">Problem Name:</td>
    //             <td className="BaseFont">{bodyData.name || ""}</td>
    //             <td className="FLabel" width="15%">Case Name:</td>
    //             <td className="BaseFont">{bodyData.Case_Name || bodyData.case_name}</td>
                
    //           </tr>
    //           <tr>
    //             <td className="FLabel">Assigned To:</td>
    //             <td className="BaseFont">{bodyData.user_name || ""}</td>
    //             <td className="FLabel">Main Diagnosis:</td>
    //             <td className="BaseFont">{bodyData.diagnosis || ""}</td>
    //           </tr>
              
    //           {(bodyData.Case_Phase || bodyData.case_phase) && (
    //             <tr>
    //               <td className="FLabel">Case Phase:</td>
    //               <td className="BaseFont">{bodyData.Case_Phase || bodyData.case_phase}</td>
    //               <td className="FLabel">Case PCP:</td>
    //               <td className="BaseFont">{bodyData.Case_PCP || bodyData.case_pcp}</td>
    //             </tr>
    //           )}
    //           {(bodyData.Open_Reason || bodyData.open_reason) && (
    //             <tr>
    //               <td className="FLabel">Open Reason:</td>
    //               <td className="BaseFont" colSpan="3">{bodyData.Open_Reason || bodyData.open_reason}</td>
    //             </tr>
    //           )}
    //           {(bodyData.Open_Notes || bodyData.open_notes) && (
    //             <tr>
    //               <td className="FLabel">Open Notes:</td>
    //               <td className="BaseFont" colSpan="3">{bodyData.Open_Notes || bodyData.open_notes}</td>
    //             </tr>
    //           )}
    //         </tbody>
    //       </table>
    //     </div>
    //   );
    // }
     // For expense notes (Type_Id: 15, event_Id: 1)
      if (note.type_Id === 15 && note.event_Id === 1) {
        return (
          <div className="type-expense">
            <table className="data-table" style={{ width: '100%' }}>
              <tbody>        
                <tr>
                  <td className="FLabel">From Date:</td>
                  <td className="BaseFont">{bodyData.from_date || ''}</td>
                  <td className="FLabel">Expense Type:</td>
                  <td className="BaseFont">{bodyData.exp_type_str || ''}</td>
                </tr>
                <tr>
                  <td className="FLabel">Quantity:</td>
                  <td className="BaseFont">{bodyData.quantity || ''}</td>
                  <td className="FLabel">Cost:</td>
                  <td className="BaseFont">{bodyData.exp_cost || ''}</td>
                </tr>
                <tr>
                  <td className="FLabel">Notes:</td>
                  <td className="BaseFont" colSpan={3} style={{ whiteSpace: 'pre-line' }}>{bodyData.notes || ''}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }


    //Testing the code
     if (note.type_Id === 4 && note.event_Id === 7) {
      //let bodyData = typeof note.body === 'string' ? JSON.parse(note.body) : note.body;
      return (
        <div className="type-task">
          <table className="data-table" >
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Task Subject:</td>
                <td className="BaseFont" style={{ width: '32%'}}>{bodyData.task_subject || ''}</td>
                <td className="FLabel" style={{ width: '18%', }}>Task Source:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.task_source || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%'}}>Task Priority:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.task_priority || ''}</td>
                <td className="FLabel" style={{ width: '18%'}}></td>
                <td className="BaseFont" style={{ width: '32%'}}></td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    // Manual Task rendering for event_Id === 8 and type_Id === 4
    if (note.type_Id === 4 && note.event_Id === 8) {
      return (
        <div className="type-task">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Task Subject:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.task_subject || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}>Task Source:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.task_source || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Task Priority:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.task_priority || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}></td>
                <td className="BaseFont" style={{ width: '32%' }}></td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Task Due Date:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.task_due_date || ''}</td>
                <td className="FLabel" style={{ width: '18%' }}>Recipient Name:</td>
                <td className="BaseFont" style={{ width: '32%' }}>{bodyData.task_recipient_name || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ width: '18%' }}>Request Note:</td>
                <td className="BaseFont" style={{ width: '32%' }}>
                  {bodyData.task_requestNote ? (
                    <span dangerouslySetInnerHTML={{ __html: bodyData.task_requestNote.replace(/<[^>]+>/g, '') }} />
                  ) : ''}
                </td>
                <td className="FLabel" style={{ width: '18%' }}>Response Note:</td>
                <td className="BaseFont" style={{ width: '32%' }}>
                  {bodyData.task_responseNote ? (
                    <span dangerouslySetInnerHTML={{ __html: bodyData.task_responseNote.replace(/<[^>]+>/g, '') }} />
                  ) : ''}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

    if (note.type_Id === 6 && note.event_Id === 43) {
  return (
    <div className="type-case-update">
      <table className="data-table" style={{ width: '100%' }}>
        <tbody>
          <tr>
            <td className="FLabel" style={{ width: '25%' }}>Problem Name:</td>
            <td className="BaseFont" style={{ width: '25%' }}>{bodyData.name || ''}</td>
            <td className="FLabel" style={{ width: '25%' }}>Case Name:</td>
            <td className="BaseFont" style={{ width: '25%' }}>{bodyData.case_name || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Assigned To:</td>
            <td className="BaseFont">{bodyData.user_name || ''}</td>
            <td className="FLabel">Main Diagnosis:</td>
            <td className="BaseFont">{bodyData.diagnosis || ''}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

if (note.type_Id === 6 && note.event_Id === 2) {
  return (
    <div className="type-case-update">
      <table className="data-table" style={{ width: '100%' }}>
        <tbody>
          <tr>
            <td className="FLabel" style={{ width: '25%' }}>Problem Name:</td>
            <td className="BaseFont" style={{ width: '25%' }}>{bodyData.name || ''}</td>
            <td className="FLabel" style={{ width: '25%' }}>Case Name:</td>
            <td className="BaseFont" style={{ width: '25%' }}>{bodyData.case_name || ''}</td>
          </tr>
          <tr>
            <td className="FLabel">Assigned To:</td>
            <td className="BaseFont">{bodyData.user_name || ''}</td>
            <td className="FLabel">Main Diagnosis:</td>
            <td className="BaseFont">{bodyData.diagnosis || ''}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

if (note.type_Id === 7 && note.event_Id === 52 ) {
  return (
    <div className="type-member-contact-record">
      <div dangerouslySetInnerHTML={{ __html: bodyData.html }} />
    </div>
  );
}
if (note.type_Id === 7 && note.event_Id === 50 ) {
  return (
    <div className="type-member-contact-record">
      <div dangerouslySetInnerHTML={{ __html: bodyData.html }} />
    </div>
  );
}

 if (note.type_Id === 4 && note.event_Id === 31 ) {
      return (
        <div className="type-task-note">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '20%' }}>Task Subject:</td>
                <td className="BaseFont" style={{ width: '30%' }}>{bodyData.task_subject || ''}</td>
                <td className="FLabel" style={{ width: '20%' }}>Task Source:</td>
                <td className="BaseFont" style={{ width: '30%' }}>{bodyData.task_source || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Task Priority:</td>
                <td className="BaseFont">{bodyData.task_priority || ''}</td>
                <td className="FLabel">Task Due Date:</td>
                <td className="BaseFont">{bodyData.task_due_date || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Recipient Name:</td>
                <td className="BaseFont">{bodyData.task_recipient_name || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Request Note:</td>
                <td className="BaseFont" colSpan="3">
                  {bodyData.task_requestNote ? (
                    <div dangerouslySetInnerHTML={{ __html: bodyData.task_requestNote }} />
                  ) : ''}
                </td>
              </tr>
              <tr>
                <td className="FLabel">Response Note:</td>
                <td className="BaseFont" colSpan="3">{bodyData.task_responseNote || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
 if (note.type_Id === 4 && note.event_Id === 30 ) {
      return (
        <div className="type-task-note">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '20%' }}>Task Subject:</td>
                <td className="BaseFont" style={{ width: '30%' }}>{bodyData.task_subject || ''}</td>
                <td className="FLabel" style={{ width: '20%' }}>Task Source:</td>
                <td className="BaseFont" style={{ width: '30%' }}>{bodyData.task_source || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Task Priority:</td>
                <td className="BaseFont">{bodyData.task_priority || ''}</td>
                <td className="FLabel">Task Due Date:</td>
                <td className="BaseFont">{bodyData.task_due_date || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Recipient Name:</td>
                <td className="BaseFont">{bodyData.task_recipient_name || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Request Note:</td>
                <td className="BaseFont" colSpan="3">
                  {bodyData.task_requestNote ? (
                    <div dangerouslySetInnerHTML={{ __html: bodyData.task_requestNote }} />
                  ) : ''}
                </td>
              </tr>
              <tr>
                <td className="FLabel">Response Note:</td>
                <td className="BaseFont" colSpan="3">{bodyData.task_responseNote || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
// For manual task notes (event_Id: 31, type_Id: 4, rank 61)
    if (note.type_Id === 4 && note.event_Id === 31 && note.rank === 61 ) {
      return (
        <div className="type-task-note">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '15%', color: '#005fa3', fontWeight: 'bold' }}>Date:</td>
                <td className="BaseFont" style={{ width: '35%' }}>{bodyData.task_due_date || ''}</td>
                <td className="FLabel" style={{ width: '15%', color: '#005fa3', fontWeight: 'bold' }}>Registrar:</td>
                <td className="BaseFont" style={{ width: '35%' }}>{note.registrar || bodyData.task_recipient_name || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Request Note:</td>
                <td className="BaseFont" colSpan="3">
                  {bodyData.task_requestNote ? (
                    <div dangerouslySetInnerHTML={{ __html: bodyData.task_requestNote }} />
                  ) : ''}
                </td>
              </tr>
              <tr>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Response Note:</td>
                <td className="BaseFont" colSpan="3">{bodyData.task_responseNote || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Task Subject:</td>
                <td className="BaseFont">{bodyData.task_subject || ''}</td>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Task Source:</td>
                <td className="BaseFont">{bodyData.task_source || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Task Priority:</td>
                <td className="BaseFont">{bodyData.task_priority || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
     if (note.type_Id === 7 && note.event_Id === 31  ) {
      return (
        <div className="type-task-note">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '15%', color: '#005fa3', fontWeight: 'bold' }}>Date:</td>
                <td className="BaseFont" style={{ width: '35%' }}>{bodyData.task_due_date || ''}</td>
                <td className="FLabel" style={{ width: '15%', color: '#005fa3', fontWeight: 'bold' }}>Registrar:</td>
                <td className="BaseFont" style={{ width: '35%' }}>{note.registrar || bodyData.task_recipient_name || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Request Note:</td>
                <td className="BaseFont" colSpan="3">
                  {bodyData.task_requestNote ? (
                    <div dangerouslySetInnerHTML={{ __html: bodyData.task_requestNote }} />
                  ) : ''}
                </td>
              </tr>
              <tr>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Response Note:</td>
                <td className="BaseFont" colSpan="3">{bodyData.task_responseNote || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Task Subject:</td>
                <td className="BaseFont">{bodyData.task_subject || ''}</td>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Task Source:</td>
                <td className="BaseFont">{bodyData.task_source || ''}</td>
              </tr>
              <tr>
                <td className="FLabel" style={{ color: '#005fa3', fontWeight: 'bold' }}>Task Priority:</td>
                <td className="BaseFont">{bodyData.task_priority || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
     if (note.type_Id === 4 && note.event_Id === 56) {
      return (
        <div className="type-task-note">
          <table className="data-table" style={{ width: '100%' }}>
            <tbody>
              <tr>
                <td className="FLabel" style={{ width: '20%' }}>Task Subject:</td>
                <td className="BaseFont" style={{ width: '30%' }}>{bodyData.task_subject || ''}</td>
                <td className="FLabel" style={{ width: '20%' }}>Task Source:</td>
                <td className="BaseFont" style={{ width: '30%' }}>{bodyData.task_source || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Task Priority:</td>
                <td className="BaseFont">{bodyData.task_priority || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Assigned From:</td>
                <td className="BaseFont">{bodyData.task_assigned_from || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Assigned To:</td>
                <td className="BaseFont">{bodyData.task_assigned_to || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Assigned By:</td>
                <td className="BaseFont">{bodyData.task_assigned_by || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }

     if (note.type_Id === 47 && note.event_Id === 1) {
      return (
        <div className="type-goal-note">
          <div style={{ marginTop: '16px', fontSize: '1.1rem', color: '#222' }}>
            {bodyData.html}
          </div>
        </div>
      );
    }

      // For member contact record HTML notes (Type_Id: 7, event_Id: 8)
      if (note.type_Id === 7 && note.event_Id === 8) {
        const bodyData = typeof note.body === 'string' ? JSON.parse(note.body) : note.body;
        return (
          <div className="type-member-contact-record">
            <div style={{ fontWeight: 'bold', textAlign: 'center', margin: '24px 0' }}>
              <span dangerouslySetInnerHTML={{ __html: bodyData.html }} />
            </div>
          </div>
        );
      }
    if (note.type_Id === 38 && note.event_Id === 26) {
      return (
        <div className="type-description-note">
          <div style={{ marginTop: '16px', fontSize: '1.1rem', color: '#222' }}>
            {bodyData.description}
          </div>
        </div>
      );
    }

    if (note.type_Id === 20 && note.event_Id === 71) {
      const bodyData = typeof note.body === 'string' ? JSON.parse(note.body) : note.body;
      const udf = bodyData.UDF || [];
      const medications = bodyData.MEDICATION || [];
      // Find UDF fields by id
      const snapshotDateLabel = udf.find(u => u.id === 'VF_01')?.name || 'Snapshot My Date';
      const snapshotTextLabel = udf.find(u => u.id === 'VF_02')?.name || 'Snapshot My Text';
      return (
        <div className="type-medication-list">
          <table className="data-table" style={{ width: '100%', marginBottom: 8, borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', fontWeight: 'bold' }} colSpan={5}>Notes: </th>
                <th colSpan={4} style={{ textAlign: 'center', fontWeight: 'bold' }}>{snapshotTextLabel} :</th>
              </tr>
              <tr>
                 <th style={{ textAlign: 'left', fontWeight: 'bold' }} colSpan={5}>{snapshotDateLabel} :</th>
              </tr>
              <tr>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 110 }}>NDC</th>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 140 }}>Drug Name</th>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 80 }}>Dosage</th>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 100 }}>Frequency</th>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 110 }}>Route</th>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 90 }}>Refills Count</th>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 90 }}>Last Refill</th>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 110 }}>Recorded Date</th>
                <th style={{ textAlign: 'left', fontWeight: 'bold', minWidth: 110 }}>Source</th>
              </tr>
            </thead>
            <tbody>
              {medications.map((med, idx) => (
                <tr key={med.ndc_id || idx}>
                  <td>{med.ndc_id || ''}</td>
                  <td>{med.drug_name || ''}</td>
                  <td>{med.dosage ? `${med.dosage} ${med.unit || ''}` : ''}</td>
                  <td>{med.frequency__verbose || ''}</td>
                  <td>{med.route || ''}</td>
                  <td>{med.refill_count || ''}</td>
                  <td>{med.refill_date || ''}</td>
                  <td>{med.medical_date || ''}</td>
                  <td>{med.owner__verbose || ''}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }


     if (note.type_Id === 3 && note.event_Id === 54 && bodyData.MILESTONE && Array.isArray(bodyData.MILESTONE)) {
      return (
        <div className="type-milestone-list">
          {bodyData.MILESTONE.map((ms, idx) => (
            <div key={idx} style={{ padding: 16, marginBottom: 16 }}>
              <table style={{ width: '100%' }}>
                <tbody>
                  <tr>
                    <td className="FLabel" style={{ width: '25%', fontWeight: 'bold', color: 'black' }}>Member Priority:</td>
                    <td className="BaseFont" style={{ width: '25%' }}>{ms.ms_member_goal_priority_id_verbose || ''}</td>
                    <td className="FLabel" style={{ width: '25%', fontWeight: 'bold', color: 'black' }}>Milestone Action Type:</td>
                    <td className="BaseFont" style={{ width: '25%' }}>{ms.ms_action_type_verbose || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Target:</td>
                    <td className="BaseFont">{ms.ms_target_mask_string || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Due Date:</td>
                    <td className="BaseFont">{ms.ms_due_date || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Original Due Date:</td>
                    <td className="BaseFont">{ms.ms_original_due_date || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Associated Goal:</td>
                    <td className="BaseFont">{ms.ms_goal || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Additional Notes:</td>
                    <td className="BaseFont">{ms.ms_additional_notes || ''}</td>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Type:</td>
                    <td className="BaseFont">{ms.ms_type_verbose || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Milestone Name:</td>
                    <td className="BaseFont" colSpan={3}>{ms.ms_name || ''}</td>
                  </tr>
                  <tr>
                    <td className="FLabel" style={{ fontWeight: 'bold', color: 'black' }}>Assigned To:</td>
                    <td className="BaseFont" colSpan={3}>{ms.ms_user_name || ''}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          ))}
        </div>
      );
    }
    
    //End
    if (note.type_Id === 1) {
      if (note.event_Id === 16) {
        return (
          <div className="type-user-role">
            <table className="data-table" width="100%">
              <tbody>
                <tr>
                  <td className="FLabel" width="10%">From:</td>
                  <td className="BaseFont" width="20%">{bodyData.from_user_name}</td>
                  <td className="FLabel" width="10%">To:</td>
                  <td className="BaseFont" width="20%">{bodyData.do_user_name}</td>
                  <td className="FLabel">Role:</td>
                  <td className="BaseFont" width="30%">{bodyData.role_string}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      } else if (note.event_Id === 47) {
        return (
          <div className="type-user-role">
            <table className="data-table" width="100%">
              <tbody>
                <tr>
                  <td className="FLabel" width="10%">Patient:</td>
                  <td className="BaseFont" width="25%">{bodyData.patient_name}</td>
                  <td className="FLabel" width="10%">Case:</td>
                  <td className="BaseFont" width="55%">{bodyData.case_name}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      } else {
        return (
          <div className="type-user-role">
            <table className="data-table" width="100%">
              <tbody>
                <tr>
                  <td className="FLabel" width="10%">User Name:</td>
                  <td className="BaseFont" width="30%">{bodyData.do_user_name}</td>
                  <td className="FLabel" width="5%">Role:</td>
                  <td className="BaseFont" width="35%">{bodyData.role_string}</td>
                  <td className="FLabel" width="10%">Primary:</td>
                  <td className="BaseFont" width="10%">{bodyData.as_primary}</td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      }
    }
   // End
    // ...existing code...
    // For milestone status change (Type_Id: 3, event_Id: 42)
    if (note.type_Id === 3 && note.event_Id === 42) {
      return (
        <div className="type-milestone-status-change">
          <table className="data-table">
            <tbody>
              <tr>
                <td className="FLabel" width="15%">Case:</td>
                <td className="BaseFont">{bodyData.case_name || ''}</td>
                <td className="FLabel" width="15%">Member Priority:</td>
                <td className="BaseFont">{bodyData.member_priority || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Problem:</td>
                <td className="BaseFont">{bodyData.problem || 'Diabetes in Pregnancy: Nutrition'}</td>
                <td className="FLabel">Assigned To:</td>
                <td className="BaseFont">{bodyData.assigned_to || bodyData.Assigned_To || 'Charlene Creese'}</td>
              </tr>
              <tr>
                <td className="FLabel">Creation Date:</td>
                <td className="BaseFont">{bodyData.creation_date || bodyData.Creation_Date || '9/1/2021'}</td>
                <td className="FLabel">Due Date:</td>
                <td className="BaseFont">{bodyData.due_date || bodyData.Due_Date || '10/31/2021'}</td>
              </tr>
              <tr>
                <td className="FLabel">Completion Date:</td>
                <td className="BaseFont">{bodyData.completion_date || bodyData.Completion_Date || '9/1/2021 12:12:12 PM'}</td>
                <td className="FLabel">Original Status:</td>
                <td className="BaseFont">{bodyData.original_status || bodyData.Original_Status || 'Future'}</td>
                <td className="FLabel">New Status:</td>
                <td className="BaseFont">{bodyData.changestatus || bodyData.new_status || bodyData.New_Status || ''}</td>
              </tr>
              <tr>
                <td className="FLabel">Change Reason:</td>
                <td className="BaseFont" colSpan="3">{bodyData.changereason || bodyData.change_reason || ''}</td>
              </tr>
            </tbody>
          </table>
        </div>
      );
    }
// ...existing code...

    // Default rendering for other types
    // if (bodyData) {
    //   return (
    //     <div className="default-note">
    //       <table className="data-table">
    //         <tbody>
    //           {Object.entries(bodyData).map(([key, value]) => 
    //             value && typeof value !== 'object' ? (
    //               <tr key={key}>
    //                 <td className="FLabel" width="15%">{key.replace(/_/g, ' ')}:</td>
    //                 <td className="BaseFont">{value}</td>
    //               </tr>
    //             ) : null
    //           )}
    //         </tbody>
    //       </table>
    //     </div>
    //   );
    // }
    
    return null;
  };

  return (
    <div className="full-text-view-container">
      {loading && <Loading />}
      {/* Navigation Buttons */}
      <div className="navigation-buttons">
        <button className="nav-btn active">
          FullTextView
        </button>
        <button className="nav-btn" onClick={handleListView}>
          ListView
        </button>
        <button className="nav-btn" onClick={handleExportToPDF}>
          ExportToPDF
        </button>
      </div>
      
      {/* Progress Note Details Section */}
      <div className="progress-note-section">
  {/* <h3 className="section-title" style={{ textAlign: 'left', marginLeft: 0 }}>Progress Note Details</h3> */}
        <div className="content-area">
           
          {error ? (
            <div className="error-state">{error}</div>
          ) : progressNotes && progressNotes.length > 0 ? (
            <div className="progress-notes-content">
               <h3  style={{ textAlign: 'left', marginLeft: 0,color: '#333' }}>Progress Note Details</h3>
              {progressNotes
                .slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage)
                .map((note, index) => {
                  return (
                    <div key={index + (currentPage - 1) * itemsPerPage} className="progress-note-item" style={{ border: '1px solid #222', borderRadius: '0', marginBottom: '0', background: '#fff', boxShadow: 'none', padding: '0' }}>
                      <div className="note-grid">
                        <table style={{ width: '100%' }}>
                          <tbody>
                            <tr style={{ height: '36px' }}>
                              <td className="FLabel" style={{ width: '12%', fontWeight: 'bold', color: '#222', fontSize: '12px', paddingLeft: '12px' }}>Source :</td>
                              <td className="BaseFont" style={{ width: '38%', fontWeight: 'normal', color: '#222', fontSize: '12px', paddingLeft: '8px' }}>{note.source || 'Triage'}</td>
                              <td className="FLabel" style={{ width: '12%', fontWeight: 'bold', color: '#222', fontSize: '12px', paddingLeft: '12px' }}>Date :</td>
                              <td className="BaseFont" style={{ width: '38%', fontWeight: 'normal', color: '#222', fontSize: '12px', paddingLeft: '8px' }}>
                                {note.create_Date ? new Date(note.create_Date).toLocaleString('en-US', {
                                  month: '2-digit',
                                  day: '2-digit',
                                  year: 'numeric',
                                  hour: '2-digit',
                                  minute: '2-digit',
                                  second: '2-digit',
                                  hour12: true
                                }) : ''}
                              </td>
                            </tr>
                            <tr style={{ height: '36px' }}>
                              <td className="FLabel" style={{ fontWeight: 'bold', color: '#222', fontSize: '12px', paddingLeft: '12px' }}>Subject :</td>
                              <td className="BaseFont" style={{ fontWeight: 'normal', color: '#222', fontSize: '12px', paddingLeft: '8px' }}>{note.subject || ''}</td>
                              <td className="FLabel" style={{ fontWeight: 'bold', color: '#222', fontSize: '12px', paddingLeft: '12px' }}>Registrar :</td>
                              <td className="BaseFont" style={{ fontWeight: 'normal', color: '#222', fontSize: '12px', paddingLeft: '8px' }}>{note.registrar || 'Campaigns'}</td>
                            </tr>
                            <tr style={{ height: '36px' }}>
                              <td className="FLabel" style={{ fontWeight: 'bold', color: '#222', fontSize: '12px', paddingLeft: '12px' }}>Case Id :</td>
                              <td className="BaseFont" style={{ fontWeight: 'normal', color: '#222', fontSize: '12px', paddingLeft: '8px' }}>{note.tzix_Id ? `${note.tzix_Id} - ${note.case_Name}` : ''}</td>
                            </tr>
                            <tr style={{ height: '36px' }}>
                              <td className="FLabel" style={{ fontWeight: 'bold', color: '#222', fontSize: '12px', paddingLeft: '12px' }}>Security Level :</td>
                              <td className="BaseFont" style={{ fontWeight: 'normal', color: '#222', fontSize: '12px', paddingLeft: '8px' }}>{note.security_level || 'Level4'}</td>
                            </tr>
                          </tbody>
                        </table>
                        {/* Body heading and left-aligned content below, no inner box */}
                        <div style={{ marginTop: '8px', marginBottom: '0' }}>
                          <span className="field-label" style={{ fontWeight: 'bold', color: '#222', fontSize: '12px', display: 'block', textAlign: 'left', paddingLeft: '15px' }}>Body :</span>
                          <div style={{ textAlign: 'left', paddingLeft: '0', marginTop: '2px' }}>
                            {/* Remove inner box from body content rendering */}
                            {formatBodyContent(note)}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
          ) : (
            <div className="empty-content">
              {/* No progress notes available */}
            </div>
          )}
        </div>
      </div>

      {/* Pagination using Pagination.js */}
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        totalItems={progressNotes.length}
      />
    </div>
  );
};

export default FullTextView;